export default "__VITE_ASSET__BlpMJqez__"